import { LitElement, html, css } from "lit";
import { customElement, property, state } from "lit/decorators.js";

@customElement("hollo-streaming-text")
export class HolloStreamingText extends LitElement {
  @property() text = "";
  @property({ type: Number }) speed = 15;
  @property({ type: Boolean }) enabled = true;

  @state() private displayedText = "";
  @state() private isTyping = false;
  private index = 0;
  private interval: any;

  protected firstUpdated() {
    if (this.enabled) {
      this.startTyping();
    } else {
      this.displayedText = this.text;
    }
  }

  updated(changed: Map<string, any>) {
    if (changed.has("text") && !this.enabled) {
      this.displayedText = this.text;
    }
  }

  private startTyping() {
    if (!this.text) return;
    clearInterval(this.interval);
    this.displayedText = "";
    this.index = 0;
    this.isTyping = true;

    // Snappy defaults for better UX
    const baseSpeed = this.speed || 15;
    const typingSpeed =
      this.text.length > 200 ? Math.max(2, baseSpeed / 3) : baseSpeed;

    this.interval = setInterval(() => {
      if (this.index < this.text.length) {
        this.displayedText += this.text[this.index];
        this.index++;
      } else {
        this.stopTyping();
      }
    }, typingSpeed);
  }

  private stopTyping() {
    clearInterval(this.interval);
    this.isTyping = false;
    this.displayedText = this.text;
    this.dispatchEvent(
      new CustomEvent("complete", { bubbles: true, composed: true })
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.interval);
  }

  static styles = css`
    :host {
      display: inline;
    }
    .hollo-streaming-cursor {
      display: inline-block;
      width: 2px;
      height: 0.9em;
      background: currentColor;
      margin-left: 2px;
      vertical-align: middle;
      animation: hollo-cursor-blink 0.8s infinite;
    }
    @keyframes hollo-cursor-blink {
      0%,
      100% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
    }
  `;

  render() {
    return html`${this.displayedText}${this.isTyping
      ? html`<span class="hollo-streaming-cursor"></span>`
      : ""}`;
  }
}
